import React from 'react'
import { Router } from './Router'
import { AuthProvider } from './contexts/AuthContext'
import { ThemeProvider } from './contexts/ThemeContext'
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
    return (
        <ThemeProvider>
            <AuthProvider>
                <Router />
            </AuthProvider>
        </ThemeProvider>
    )
}

export default App;